"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _theme = _interopRequireDefault(require("../../../theme"));
const useStyles = (0, _styles.makeStyles)({
  datepickerInputContainer: {
    flexWrap: 'nowrap',
    '& .MuiGrid-root:first-child .MuiInputBase-root': {
      borderRight: 'none',
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0
    },
    '& .MuiGrid-root:last-child .MuiInputBase-root': {
      borderLeft: 'none',
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0
    }
  },
  datepickerInputContainerEnd: {
    flexWrap: 'nowrap',
    '& .MuiGrid-root:first-child .MuiInputBase-root': {
      borderColor: '#005EDC'
    },
    '& .MuiGrid-root:last-child .MuiInputBase-root': {
      borderLeft: 'none',
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0
    }
  },
  datepickerInputContainerStart: {
    flexWrap: 'nowrap',
    '& .MuiGrid-root:first-child .MuiInputBase-root': {
      borderRight: 'none',
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0
    },
    '& .MuiGrid-root:last-child .MuiInputBase-root': {
      borderColor: '#005EDC'
    }
  },
  inputAdornment: {
    [_theme.default.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  inputAdornmentEnd: {
    marginLeft: '-16px !important'
  },
  datepickerInput: {
    margin: '0 !important'
  },
  gridItem: {
    [_theme.default.breakpoints.up('xs')]: {
      padding: '17px 10px 17px 10px !important'
    },
    [_theme.default.breakpoints.up('sm')]: {
      padding: '17px 10px 17px 10px !important'
    },
    [_theme.default.breakpoints.up('md')]: {
      padding: '20px 10px 20px 10px !important'
    },
    [_theme.default.breakpoints.up('lg')]: {
      padding: '20px 15px 20px 15px !important'
    }
  }
});
var _default = exports.default = useStyles;